export const READING_TYPES = [
  { value: "both", label: "KM + Hours" },
  { value: "km", label: "KM only" },
  { value: "hours", label: "Hours only" }
];

export const usesKm = (eq) => (eq?.reading_type || "both") !== "hours";
export const usesHours = (eq) => (eq?.reading_type || "both") !== "km";
export const readingTypeLabel = (eq) => READING_TYPES.find(t => t.value === (eq?.reading_type || "both"))?.label;

export const MACHINE_STATUSES = ["Working", "Idle", "Breakdown", "Under Maintenance", "No Operator"];

export const STATUS_STYLES = {
  Working: "bg-green-100 text-green-700",
  Idle: "bg-slate-200 text-slate-700",
  Breakdown: "bg-red-100 text-red-700",
  "Under Maintenance": "bg-amber-100 text-amber-700",
  "No Operator": "bg-purple-100 text-purple-700"
};
